import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { pageClickHandler } from './router-helper';

export const SettingsItem = ({ i18n, scope, siteMap }) => {
  const { adGroupId, campaignId } = scope.values;
  const isSettingsTab = _.result(_.find(siteMap, i => i.selected), 'id') === 'settings';
  if (isSettingsTab && (adGroupId || campaignId)) {
    return null;
  }

  return (
    <div className="settings-item">
      <div className="summary-bar-divider" />
      <button
        onClick={() => pageClickHandler(siteMap, scope, 'settings')}
        onKeyDown={submitEvent(() => pageClickHandler(siteMap, scope, 'settings'))}
        className="entity-content-settings"
        aria-label={i18n.getString(_TL_('Go to settings'))}
        type="button"
      >
        <Glyphicon
          className="entity-icon"
          glyph="ba-Settings"
        />
        <span className="entity-text">{i18n.getString(_TL_('Go to settings'))}</span>
      </button>
    </div>);
};

SettingsItem.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.any).isRequired,
};
